<div class="p-grid" style="margin-top:15px;">
  <div class="p-col-12 p-md-4 p-lg-4">
    <label for="selectedFilteredItem" style="margin-top:0;">Catalog* </label>
  </div>

  <div class="p-col-2 p-md-2 p-lg-2">
    <button style="margin:-5px 0 0 5px;" type="button" class="icon-action" icon="fa fa-th-list" pButton (click)="catalogOp.show($event)"></button>
    <div class="pr-catalog-menu">
      <p-overlayPanel #catalogOp [dismissable]="true" [showCloseIcon]="true" styleClass="catalog-selection-overlay">
        <p-tree [value]="catalogTree" selectionMode="single" (onNodeSelect)="nodeSelect($event, catalogOp)" [style]="{'width':'100%'}" [styleClass]="'tree-container'"
                [(selection)]="selectedCatalog">
        </p-tree>
      </p-overlayPanel>
    </div>
  </div>

  <div class="p-col-12 p-md-6 p-lg-6">
    <strong>{{ selectedCatalog?.name ? selectedCatalog?.name : '' }}</strong>
  </div>
</div>


<!-- User to search for an item after selected a catalog -->

<div class="p-grid">
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Item Name*</label>
  </div>

  <div class="p-col-12 p-md-8 p-lg-8">
    <p-autoComplete name="selectedFilteredItem" class="autoComplete" field="nameOrNumber" [placeholder]="Validation.AutoCompletePlaceholder"
                    [suggestions]="filteredItems" [minLength]="Validation.AutoCompleteMinLength" [showEmptyMessage]="true"
                    (completeMethod)="searchItem($event)"
                    [(ngModel)]="selectedItem" (onSelect)="onSelectItem(selectedItem)" (onUnselect)="selectedItem=null"
                    [disabled]="!selectedCatalog" required>
    </p-autoComplete>
  </div>
</div>

<!-- Show selected item detail including type, unit price, manufacturer number, u/m, commidity code, description and item notes -->
<div class="p-col-12" style="border:1px solid #ccc;border-radius:4px;margin:15px 0;">
  <div class="p-grid add-item-readonly">
    <div class="p-col-12 p-md-6 p-lg-6">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label class="no-top-margin">Type</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{selectedItem ? selectedItem.subtype : '' }}
        </div>
      </div>
    </div>

    <div class="p-col-12 p-md-6 p-lg-6">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label class="no-top-margin">Unit Price</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          $ {{ selectedItem ? (selectedItem.unitCost | number:'1.0-2') : '' }}
        </div>
      </div>
    </div>


    <div class="p-col-12 p-md-6 p-lg-6" *ngIf="selectedItem?.manufacturerNumber">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label class="no-top-margin">Manu #</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{selectedItem ? selectedItem.manufacturerNumber : '' }}
        </div>
      </div>
    </div>

    <div class="p-col-12 p-md-6 p-lg-6">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label class="no-top-margin">U/M</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{ selectedItem ? selectedItem.unitOfMeasureDescription : '' }}
        </div>
      </div>
    </div>

    <div class="p-col-12 p-md-6 p-lg-6" *ngIf="selectedItem?.itemNotes">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label for="itemNotes">Item Notes</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{selectedItem ? selectedItem.itemNotes : '' }}
        </div>
      </div>
    </div>
  </div>
</div>
